/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarpsaleHistoryManagementEditOrderRequest } from '../models/CarpsaleHistoryManagementEditOrderRequest';
import type { CarpsaleHistoryManagementEditOrderResponseApiRespoonse } from '../models/CarpsaleHistoryManagementEditOrderResponseApiRespoonse';
import type { CarpsaleHistoryManagementExportOrderRequest } from '../models/CarpsaleHistoryManagementExportOrderRequest';
import type { CarpsaleHistoryManagementExportOrderResponseApiRespoonse } from '../models/CarpsaleHistoryManagementExportOrderResponseApiRespoonse';
import type { CarpsaleHistoryManagementListOrderRequest } from '../models/CarpsaleHistoryManagementListOrderRequest';
import type { CarpsaleHistoryManagementListOrderResponseApiRespoonse } from '../models/CarpsaleHistoryManagementListOrderResponseApiRespoonse';
import type { CarpsaleHistoryManagementShowItemRequest } from '../models/CarpsaleHistoryManagementShowItemRequest';
import type { CarpsaleHistoryManagementShowItemResponseApiRespoonse } from '../models/CarpsaleHistoryManagementShowItemResponseApiRespoonse';
import type { CarpsaleHistoryManagementShowOrderRequest } from '../models/CarpsaleHistoryManagementShowOrderRequest';
import type { CarpsaleHistoryManagementShowOrderResponseApiRespoonse } from '../models/CarpsaleHistoryManagementShowOrderResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CarpsaleHistoryManagementCarpsaleHistoryService {

    /**
     * 注文一覧
     * @param requestBody
     * @returns CarpsaleHistoryManagementListOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleHistory(
        requestBody: CarpsaleHistoryManagementListOrderRequest,
    ): CancelablePromise<CarpsaleHistoryManagementListOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale-history',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文の更新
     * @param requestBody
     * @returns CarpsaleHistoryManagementEditOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleHistoryEdit(
        requestBody: CarpsaleHistoryManagementEditOrderRequest,
    ): CancelablePromise<CarpsaleHistoryManagementEditOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/carpsale-history/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文表示
     * @param requestBody
     * @returns CarpsaleHistoryManagementShowOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleHistoryShow(
        requestBody: CarpsaleHistoryManagementShowOrderRequest,
    ): CancelablePromise<CarpsaleHistoryManagementShowOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale-history/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文情報ダウンロードのhtml出力URL作成
     * @param requestBody
     * @returns CarpsaleHistoryManagementExportOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleHistoryExportOrder(
        requestBody: CarpsaleHistoryManagementExportOrderRequest,
    ): CancelablePromise<CarpsaleHistoryManagementExportOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale-history/export-order',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * show list items
     * @param requestBody
     * @returns CarpsaleHistoryManagementShowItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleHistoryItems(
        requestBody: CarpsaleHistoryManagementShowItemRequest,
    ): CancelablePromise<CarpsaleHistoryManagementShowItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale-history/items',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
